/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { TimesheetsService } from 'app/core/services/timesheets/timesheets.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import dayjs from 'dayjs';
import { badgeColorCode, BadgeOptions } from '../badge/badge.interface';
import { serviceContractStatus } from '../datagrid/datagrid.interface';
import { RemarksComponent } from '../remarks/remarks.component';
import { LocalStorageService } from 'app/core/services/localstorage.service';


@Component({
  selector: 'app-timeoff-details',
  templateUrl: './timeoff-details.component.html',
  styleUrls: ['./timeoff-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TimeoffDetailsComponent implements OnInit {
  timeoffData: any = {};
  hasPermissionToApproveOrReject = true;
  hasPermissionToDelete: boolean = true;
  loggedinUser: any;
  constructor(private _localisationService: LocalisationService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<TimeoffDetailsComponent>,
              private dataCollectorService: DataCollectorService,
              private timesheetsService: TimesheetsService,
              private utilityService: UtilityService,
              private toast: HotToastService,
              private zuperDialogService: ZuperDialogService,
              private localStorageService: LocalStorageService) { 
                this.loggedinUser = this.utilityService.user; 
            }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    this.timeoffData = this.data?.data;
    this.hasPermissionToApproveOrReject = this.isFEAllowedToApproveReject();
    this.hasPermissionToDelete = this.isFEAllowedToDelete();
  }

  isFEAllowedToApproveReject(): boolean{
    if(this.loggedinUser?.role?.role_key === 'FIELD_EXECUTIVE' && !this.loggedinUser?.access_role){
      return false;
    }
    return this.utilityService.hasPermission('timesheet.timeoff_accept_reject');
  }

  isFEAllowedToDelete(): boolean{
    const hasPermission = this.utilityService.hasPermission('timesheet.manage_timeoff');
    if(this.loggedinUser?.role?.role_key === 'FIELD_EXECUTIVE' && (!this.loggedinUser?.access_role || hasPermission)){
      return this.timeoffData?.approval_status === 'AWAIT_APPROVAL';
    }
    return hasPermission;
  }

  getBadgeOptions(tag: string): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: 'TAG',
      color: badgeColorCode[tag],
      displayKey: serviceContractStatus[tag],
      displayName: tag,
      extraClass: 'font-medium text-md -ml-1',
    };
    return badgeOption;
  }

  handleTimeOffEvent(action): void{
    this.dialogRef.close(false);
    switch(action){
      case 'delete':
        const deleteConfirmationMessage = `${this.utilityService.getLocaleValue('timeoff.delete.message.prefix')} ${this.utilityService.getLocaleValue('timeoff.delete.message.suffix')} - ${this.timeoffData?.requested_by?.first_name ?? ''}'s ?`;
          const deleteDialog =  this.zuperDialogService.open({
                                                                    title:`${this.utilityService.getLocaleValue('timeoff.delete.dialog.title','Delete timeoff request')}`,
                                                                    message:deleteConfirmationMessage,
                                                                    type:'error',
                                                                    actions    : {
                                                                        confirm: {
                                                                          show : true,
                                                                          label: 'Ok',
                                                                          color: 'error',
                                                                          confirmDisplayKey:'delete.text',
                                                                        },
                                                                        cancel : {
                                                                            show : true,
                                                                            label: 'Cancel'
                                                                        }
                                                                    }
                                                                  });
            deleteDialog.afterClosed().subscribe((result: any)=>{
            if(result){
              this.timesheetsService.refreshTimeOff.next(false);
              this.toast.loading(this.utilityService.getLocaleValue('timeoff.update.timeoff.requests.label','Updating Timeoff requests'),{id:'update_timeoff_requests'});
              this.dataCollectorService.deleteData(this.timesheetsService.getTimeoffDeleteUrl(this.timeoffData.request_uid)).subscribe((response: any)=>{
                this.toast.close('update_timeoff_requests');
                this.toast.success(response.message);
                this.timesheetsService.refreshTimeOff.next(true);
              },(error: any)=>{
                this.toast.close('update_timeoff_requests');
                if(error?.error?.message){
                  
                }
              });
            }
          });
        break;
      case 'REJECTED':
      case 'APPROVED':
        const getRemarksDialog = this.zuperDialogService.openCustom(RemarksComponent,{
          extraClass: 'add-time-off-dialog',
          data:{
          dialogType:'REMARKS',
          dialogTitle: action === 'REJECTED' ? `${this.utilityService.getLocaleValue('timeoff.remarks.button.reject.label','Reject')} ${this.utilityService.getLocaleValue('timeoff.remarks.timeoff.suffix.label','timeoff request of')} '${this.timeoffData?.requested_by?.first_name} ${this.timeoffData?.requested_by?.last_name}'` :
                                             `${this.utilityService.getLocaleValue('timeoff.remarks.button.approve.label','Approve')} ${this.utilityService.getLocaleValue('timeoff.remarks.timeoff.suffix.label','timeoff request of')} '${this.timeoffData?.requested_by?.first_name} ${this.timeoffData?.requested_by?.last_name}'`,
          buttonName:  action === 'REJECTED' ? 'timeoff.remarks.button.reject.label' : 'timeoff.remarks.button.approve.label',
          buttonColor: action === 'REJECTED' ? 'bg-red-600 text-white' : 'bg-primary text-white',
        }});

        getRemarksDialog.afterClosed().subscribe((result: any)=>{
          if(result){
            const payload = {
              'timeoff_request': {
                  'approval_remarks': result?.reason,
                  'approval_status': action
              }
            };
            this.timesheetsService.refreshTimeOff.next(false);
            this.toast.loading(this.utilityService.getLocaleValue('timeoff.update.timeoff.requests.label','Updating Timeoff requests'),{id:'update_timeoff_requests'});
            this.dataCollectorService.putData(this.timesheetsService.getTimeoffUpdateApproval(this.timeoffData?.request_uid),payload).subscribe((response: any)=>{
              this.toast.close('update_timeoff_requests');
              this.timesheetsService.refreshTimeOff.next(true);
              this.toast.success(response.message);
            },(error: any)=>{
              this.toast.close('update_timeoff_requests');
              if(error?.error?.message){
                
                this.dialogRef.close('openDetails');
              }
            });
          }
        });
      break;
    }
  }

  formatTimeOff(date): string{
    return dayjs(dayjs.utc(date).tz(this.utilityService.timeZone)).format(this.utilityService.dateTimeFormat);
  }

  get modelTitle(): any{
    const title = `${this.timeoffData?.requested_by?.first_name} ${this.timeoffData?.requested_by?.last_name}'s ${this.utilityService.getLocaleValue('pending.timeoff.detail.title')}`;
    return title;
  }

  closeDialog(): void{
    this.dialogRef.close();
  }
}
